import React from 'react';
import { Select, InputLabel, FormControl, MenuItem } from '@mui/material';
import { fieldToSelect, SelectProps } from 'formik-mui';
import { useTranslation } from 'react-i18next';

import { SelectItemType } from '../../definitions.d';
import useStyles from './styles';

interface SelectInputProps extends SelectProps {
  label: string;
  items: SelectItemType[];
}

const SelectInputWithTranslation: React.FunctionComponent<SelectInputProps> = (
  props: SelectInputProps
) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const selectProps = fieldToSelect(props);
  const customProps = {
    ...selectProps,
    value: selectProps.value ? selectProps.value : ''
  };

  const name = customProps.name as string;
  const error = props.form.errors[name] && props.form.touched[name];

  return (
    <FormControl
      className={classes.formControl}
      variant="outlined"
      size="small"
    >
      <InputLabel htmlFor={customProps.name}>{t(props.label)}</InputLabel>
      <Select {...customProps} error={!!error}>
        {props.items.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {t(item.label)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectInputWithTranslation;
